import { registerPlugin } from '@capacitor/core';
const Printer = registerPlugin('Printer');
export * from './definitions';
export { Printer };
//# sourceMappingURL=index.js.map